// メッセージ取得の1回あたりの上限
export const MESSAGES_GET_LIMIT = 20;

// アップロードできるファイルサイズの上限
export const FILE_SIZE_LIMIT_IMG = 5000000;
export const FILE_SIZE_LIMIT_FILE = 100000000;

// サムネイル画像の最大サイズ
export const THUMBNAIL_MAX_HEIGHT = 360;
export const THUMBNAIL_MAX_WIDTH = 640;

// エラーメッセージを表示する秒数
export const ERROR_MESSAGE_SHOW_DURATION = 3000;

// 各種エラーメッセージ
export const ERROR_MESSAGE = {
  imageLoad: '画像を読み込めませんでした。',
  imageSelect: '画像を読み込めませんでした。画像を再度選択してください。',
  imageSize: '5MB以上の画像はアップロードできません。',
  fileSize: '100MB以上のファイルはアップロードできません。',
  imageType: '画像を選択してください。',
  send: '送信に失敗しました。再度送信してください。'
};

export const ALLOW_TYPES = [
  'application/vnd.ms-excel', //Excel2003以前のExcelファイル
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //Excel2007以降のExcelファイル
  'application/msword', //Word2003以前のWordファイル
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //Word2007以降のWordファイル
  'application/vnd.ms-powerpoint', //PowerPoint2003以前のPowerPointファイル
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', //PowerPoint2007以降のPowerPointファイル
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp'
];
